<template>
  <div class="columns ta_logo_box" v-if="organisation.name === 'Homegate AG'">
    <div class="column is-narrow">
      <figure  class="logo_hg image content">
        <img src="/static/img/logo_hg.jpg" class=" company_logo"/>
      </figure>
    </div>
    <div v-if="qrcode === true">
      <div class="column content company_name">
        <!--<h4>tamedia</h4>-->
        <img src="/static/img/homegate.png" style="max-width: 87px;" class="qr_code"/>
      </div>
    </div>
  </div>

  <div class="columns ta_logo_box" v-else-if="organisation.name === 'Doodle'">
    <div class="column is-narrow">
      <figure  class="logo_dd image content">
        <img src="/static/img/logo_dd.jpg" class=" company_logo"/>
      </figure>
    </div>
    <div v-if="qrcode === true">
      <div class="column content company_name">
        <!--<h4>tamedia</h4>-->
        <img src="/static/img/doodle.png" style="max-width: 87px;" class="qr_code"/>
      </div>
    </div>
  </div>

  <div class="columns ta_logo_box" v-else-if="organisation.name === 'ricardo.ch AG'">
    <div class="column is-narrow">
      <figure  class="logo_ri image content">
        <img src="/static/img/logo_ri.jpg" class=" company_logo "/>
      </figure>
    </div>
    <div v-if="qrcode === true">
      <div class="column content company_name">
        <!--<h4>tamedia</h4>-->
        <img src="/static/img/ricardo.png" style="max-width: 87px;" class="qr_code"/>
      </div>
    </div>
  </div>

  <div class="columns ta_logo_box" v-else-if="organisation.name === 'Starticket'">
    <div class="column is-narrow">
      <figure  class="logo_st image content">
        <img src="/static/img/logo_sk_black_blue.jpg" class=" company_logo "/>
      </figure>
    </div>
    <div v-if="qrcode === true">
      <div class="column content company_name">
        <!--<h4>tamedia</h4>-->
        <img src="/static/img/starticket.png" style="max-width: 87px;" class="qr_code" />
      </div>
    </div>
  </div>

  <div class="columns ta_logo_box" v-else-if="organisation.name === 'OLMeRO'">
    <div class="column is-narrow">
      <figure  class="logo_ol image content">
        <img src="/static/img/logo_ol.jpg" class=" company_logo "/>
      </figure>
    </div>
    <div v-if="qrcode === true">
      <div class="column content company_name" >
        <!--<h4>tamedia</h4>-->
        <img src="/static/img/olmero.png" style="max-width: 87px;" class="qr_code"/>
      </div>
    </div>
  </div>

  <div class="columns ta_logo_box" v-else-if="organisation.name === 'Tutti'">
    <div class="column is-narrow">
      <figure  class="logo_tu image content">
        <img src="/static/img/logo_tu.jpg" class=" company_logo "/>
      </figure>
    </div>
    <div v-if="qrcode === true">
      <div class="column content company_name">
        <!--<h4>tamedia</h4>-->
        <img src="/static/img/tutti.png" style="max-width: 87px;" class="qr_code"/>
      </div>
    </div>
  </div>

  <div class="columns ta_logo_box" v-else-if="organisation.name === 'Product & UX'">
    <div class="column is-narrow">
      <figure  class="logo_p image content">
        <img src="/static/img/logo_pux.png" class=" company_logo "/>
      </figure>
    </div>
    <div v-if="qrcode === true">
      <div class="column content company_name">
        <!--<h4>tamedia</h4>-->
        <img src="/static/img/pux.png" style="max-width: 87px;" class="qr_code"/>
      </div>
    </div>
  </div>

  <div class="columns ta_logo_box" v-else-if="organisation.name === 'Tamedia AG'">
    <div class="column is-narrow">
      <figure class="logo_ta image content">
        <img src="/static/img/logo_tamedia_red.jpg" class=" company_logo "/>
      </figure>
    </div>
    <div v-if="qrcode === true">
      <div class="column content company_name">
        <!--<h4>tamedia</h4>-->
        <img src="/static/img/tamedia.png" style="max-width: 87px;" class="qr_code"/>
      </div>
    </div>
  </div>
  <h2 v-else class="title">{{organisation.name}}</h2>
</template>

<script>
  export default {
    name: 'job-logos',
    props: ['organisation', 'qrcode'],

  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/jobs/JobLogos.vue